import { useContext } from "react";
import { AuthContext } from "./AuthContext";

export const useAuthenticator = () => {
  return useContext(AuthContext);
};
